import { LearnMore } from '../../LearnMore';
import { OpportunitiesTable, PresentersTable } from '../SharedSections';
import { TotalPresentations } from '../SharedSections/TotalPresentations';
import { DemosTable } from './DemosTable/DemosTable';
import { EnvironmentActivityChart } from './EnvironmentActivityChart';
import { EnvironmentSessionBreakdown } from './EnvironmentSessionBreakdown';
import { TotalVisits } from './TotalVisits';

export const EnvironmentDashboard = () => (
  <div className="w-ds-page grid grid-cols-[repeat(3,_minmax(340px,_400px))] grid-rows-[325px_min-content_378px] gap-6 pt-9 items-stretch">
    <TotalPresentations />
    <TotalVisits />
    <OpportunitiesTable maxItems={4} />
    <div className="col-span-full ">
      <EnvironmentActivityChart />
    </div>
    <PresentersTable maxItems={5} />
    <div className="col-span-2 [&>div]:h-full">
      <DemosTable />
    </div>
    <div className="col-span-full">
      <EnvironmentSessionBreakdown />
    </div>
    <div className="col-span-full">
      <LearnMore />
    </div>
  </div>
);
